<template>
  <c-step :items="stepItems" v-model="step"></c-step>
</template>

<script>
export default {
  name: 'compliance-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({

      }),
    },
  },
  data() {
    return {
      step: 1,
      stepItems: [
        {
          name: 1,
          title: '감사계획',
          icone: '',
          disable: false,
          message: '',
          component: () => import(`${'./plan/compliancePlan.vue'}`),
          param: {
            a: 1,
            b: 'c'
          }
        },
        {
          name: 2,
          title: '감사실행',
          icone: '',
          disable: false,
          message: '',
          component: () => import(`${'./run/complianceRun.vue'}`),
          param: {
            a: 2,
            b: 'c'
          }
        },
        {
          name: 3,
          title: '시정조치 계획 및 실행',
          icone: '',
          disable: false,
          message: '',
          component: () => import(`${'./action/complianceAction.vue'}`),
          param: {
            a: 2,
            b: 'c'
          }
        },
        {
          name: 4,
          title: '감사결과',
          icone: '',
          disable: false,
          message: '',
          component: () => import(`${'./result/complianceResult.vue'}`),
          param: {
            a: 5,
            b: 'c'
          }
        },
      ],
      editable: true,
      detailUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.getList();
    },
    getList() {
    },
  }
};
</script>
